export function computePrewarmTimings(state) {
  const { collectTs, prewarmStartTs, moduleLoadTs, localSettled, globalSettled } = state;
  return {
    markerPrewarmLeadMs: prewarmStartTs != null ? Math.max(0, collectTs - prewarmStartTs) : 0,
    sdkLoadToCollectMs: collectTs - moduleLoadTs,
    markerPrewarmHit: !!localSettled,
    markerGlobalPrewarmHit: !!globalSettled,
  };
}
